import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

interface IIsActive {
    isActive?: boolean;
}
interface IIsVisited {
    isVisited?: boolean;
}

const Circle = styled.div<IIsActive & IIsVisited>`
    width: 24px;
    height: 24px;
    font-size: 14px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: ${(props) =>
        props.isVisited || props.isActive ? colorsPalettes.blue["400"] : colorsPalettes.carbon["200"]};

    svg path {
        fill: white;
    }
`;

const Container = styled.div<IIsActive>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 52px;
    transition: all 0.2s ease-in-out;
    opacity: ${(props) => (props.isActive ? 1 : 0.6)};
`;

interface ITextProps {
    alignText?: "left";
}

const Text = styled.span<ITextProps>`
    position: relative;
    top: 4px;
    font-size: 12px;
    color: ${colorsPalettes.carbon["500"]};
    white-space: nowrap;
    display: inline-block;
    max-width: 228px;
    text-overflow: ellipsis;
    overflow: hidden;
    ${({ alignText }) =>
        alignText === "left" &&
        css`
            transform: translateX(calc(50% - 12px));
        `}
`;

interface IDefaultLegendItemProps extends ITextProps, IIsActive, IIsVisited {
    label: string;
    step: number;
}

export const DefaultLegendItem = ({ isActive, isVisited, step, label, alignText }: IDefaultLegendItemProps) => {
    const translate = useTranslation();

    return (
        <Container isActive={isActive}>
            <Circle
                isActive={isActive}
                isVisited={isVisited}
            >
                {isVisited ? (
                    <SWReactIcons
                        iconName="checked"
                        size="xs"
                    />
                ) : (
                    step + 1
                )}
            </Circle>
            <Text alignText={alignText}>{translate(label)}</Text>
        </Container>
    );
};
